import PropTypes from 'prop-types';

export const filingGroupPropTypes = PropTypes.shape({
  filingGroup: PropTypes.string,
  filingGroupId: PropTypes.string,
  jurisdiction: PropTypes.string,
  jurisdictionId: PropTypes.string,
});
